module.exports = __webpack_public_path__ + "static/img/img_member_ad.3ae2fb40.png";